import React from "react";
import { Card } from "react-bootstrap";
import icon1 from "../../../Icons/accountIcon4.png";

const SummaryCard = ({ title, value, change, type, background, icon }) => {
  const changeIcon = type === "up" ? "↑" : "↓";
  //   const bgClass = `bg-${color}`;

  return (
    <div style={{ paddingRight: "3%" ,height:"100%"}}>
      <Card
        className={`text-white h-100 w-100`}
        style={{ backgroundColor: background }}
      >
        <Card.Body style={{ padding: "17px" }}>
          <div style={{ display: "flex" ,justifyContent:"space-between"}}>
            <div style={{ display: "flex" }}>
              <img
                src={icon}
                alt="pic"
                style={{ height: "84%", width: "16%" }}
              />
              <p>{title}</p>
            </div>
            <div>
              <img src={icon1} alt="icon" />
            </div>
          </div>
          <p style={{ fontSize: "28px", paddingTop: "18px" }}>{value}</p>

          <div style={{display: "flex",justifyContent: "space-between",fontSize: "14px"}}>
            <div>
              <p>vs last month</p>
            </div>
            <div>
              <p>
                {change} {changeIcon}
              </p>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default SummaryCard;
